import type { BaseDisplayAttribute } from '@/models/base-display-attribute';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

export const entityFieldsQueryOptions = (entityTypeId: string) => {
  return queryOptions({
    queryKey: ['fields', entityTypeId],
    queryFn: async () => {
      if (!entityTypeId) {
        return [];
      }

      const response = await axios.get<BaseDisplayAttribute[]>(
        `/${entityTypeId}/fields`
      );
      if (response.status !== 200) {
        throw new Error('Failed to fetch fields');
      }
      return response.data;
    },
  });
};
